"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerProfileService = void 0;
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var _services_1 = require("@/_services");
var CustomerProfileService = /** @class */ (function () {
    function CustomerProfileService(http, authenticationService) {
        this.http = http;
        this.authenticationService = authenticationService;
        this.httpClient = http;
        this.get_gcdm_config = this.authenticationService.get_config();
    }
    CustomerProfileService.prototype.getCustomerInfo = function (token) {
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': "Bearer " + token });
        var configs = { headers: headers };
        return this.http.get(this.get_gcdm_config['CP_hostname'] + "/customerportalapi/rest/cp/crm/customer/get-customer/customer", configs)
            .pipe(operators_1.map(function (data) { return data; }));
    };
    //     getCustInfoUsingGcid(gicd:string): Observable<any>{
    //         return this.http.get<any>(this.get_gcdm_config['CP_hostname']+"/customerportalapi/rest/cp/crm/customer/customer-bp-search/"+gicd+"/ZGGCID")
    //        .pipe(map(data =>  data as any));
    //    }
    CustomerProfileService.prototype.getOnDemandGetCustInfo = function (id, idType) {
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': "Bearer " + sessionStorage.getItem('CP_OAUTH_BEARER_TOKEN'),
            'idNo': id, 'idType': idType });
        var configs = { headers: headers };
        return this.http.get(this.get_gcdm_config['CP_hostname'] + "/customerportalapi/rest/cp/crm/customer/search-customer/customer", configs)
            .pipe(operators_1.map(function (data) { return data; }));
    };
    CustomerProfileService = __decorate([
        core_1.Injectable({ providedIn: 'root' }),
        __metadata("design:paramtypes", [http_1.HttpClient, _services_1.AuthenticationService])
    ], CustomerProfileService);
    return CustomerProfileService;
}());
exports.CustomerProfileService = CustomerProfileService;
